import React from "react";
import { Link } from "react-router-dom";
import { assets, onAssetError } from "./assets";
import { ABOUT_STATS, MISSION_VISION, SMALL_ARTICLES, TEAM, VALUES } from "./data";
import { ArrowRight } from "./icons";
import { useLanding } from "./LandingContext";

export function AboutPage() {
  const { goTo } = useLanding();

  return (
    <>
      <div id="about" style={{ padding: 0 }} data-screen-label="AboutHero">
        <div
          style={{
            width: "100%",
            position: "relative",
            borderRadius: "0 0 40px 40px",
            overflow: "hidden",
            minHeight: "78vh",
            marginTop: -84,
          }}
        >
          <div style={{ position: "absolute", inset: 0 }}>
            <img src={assets.hero} alt="" onError={onAssetError} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
          </div>
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "linear-gradient(180deg, rgba(12,6,7,0.7) 0%, rgba(12,6,7,0.42) 42%, rgba(12,6,7,0.82) 100%)",
              pointerEvents: "none",
            }}
          />
          <div
            className="rv in"
            style={{
              position: "relative",
              zIndex: 2,
              padding: "156px clamp(20px, 6vw, 70px) 120px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              minHeight: "78vh",
              maxWidth: 1240,
              margin: "0 auto",
            }}
          >
            <div className="rvc" style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.28em", textTransform: "uppercase", color: "rgba(255,255,255,0.72)" }}>
              About Chainz
            </div>
            <div
              className="rvc"
              style={{
                fontSize: "clamp(36px, 7.5vw, 68px)",
                fontWeight: 300,
                lineHeight: 1.03,
                letterSpacing: "-0.025em",
                color: "#fff",
                maxWidth: 920,
                marginTop: 18,
                textWrap: "balance",
                textShadow: "0 4px 26px rgba(0,0,0,0.55)",
              }}
            >
              We built the operations layer
              <br />
              <span style={{ fontWeight: 800 }}>Egypt's brands were missing.</span>
            </div>
            <div
              className="rvc"
              style={{
                fontSize: "clamp(15px, 2.2vw, 18px)",
                lineHeight: 1.65,
                color: "rgba(255,255,255,0.9)",
                marginTop: 20,
                maxWidth: 560,
                textWrap: "pretty",
                textShadow: "0 2px 16px rgba(0,0,0,0.5)",
              }}
            >
              Chainz started as a warehouse and became a system — storage, fulfillment, delivery and cash collection, run end to end.
            </div>
          </div>
        </div>

        <div style={{ padding: "0 clamp(16px, 4vw, 40px)", marginTop: -58, position: "relative", zIndex: 5 }}>
          <div className="statband rv card" style={{ maxWidth: 1120, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(3, 1fr)", padding: "34px 30px" }}>
            {ABOUT_STATS.map((s) => (
              <div key={s.l} style={{ textAlign: "center", padding: "0 10px", borderLeft: `1px solid ${s.divider}` }}>
                <div style={{ fontSize: "clamp(26px, 5vw, 40px)", fontWeight: 800, letterSpacing: "-0.02em" }}>{s.n}</div>
                <div style={{ fontSize: 12.5, color: "#6b6470", marginTop: 5 }}>{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div id="team" style={{ padding: "96px clamp(16px, 4vw, 40px) 20px" }} data-screen-label="Team">
        <div style={{ maxWidth: 1120, margin: "0 auto" }}>
          <div
            className="rv"
            style={{
              display: "flex",
              alignItems: "flex-end",
              gap: 20,
              marginBottom: 52,
              flexWrap: "wrap",
              borderBottom: "1px solid rgba(26,20,22,0.12)",
              paddingBottom: 20,
            }}
          >
            <div style={{ fontSize: "clamp(28px, 6vw, 42px)", fontWeight: 800, letterSpacing: "-0.015em", lineHeight: 1.05 }}>
              Led by operators,
              <br />
              not consultants
            </div>
            <div style={{ marginLeft: "auto", fontSize: 14, color: "#6b6470", maxWidth: 300, lineHeight: 1.6 }}>
              The people who built the warehouse still run it.
            </div>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 72 }}>
            {TEAM.map((m) => (
              <div key={m.name} className={`trow rv${m.rev ? " rev" : ""}`} style={{ display: "grid", gap: 48, alignItems: "center" }}>
                <div
                  className="tportrait"
                  style={{
                    order: m.rev ? 1 : 0,
                    position: "relative",
                    aspectRatio: "3 / 4",
                    borderRadius: 28,
                    overflow: "hidden",
                    boxShadow: "0 34px 70px rgba(50,25,30,0.2)",
                  }}
                >
                  <img src={m.src} alt={m.name} onError={onAssetError} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
                </div>
                <div style={{ order: m.rev ? 0 : 1 }}>
                  <div className="qmark">&ldquo;</div>
                  <div
                    style={{
                      fontSize: "clamp(21px, 3.2vw, 30px)",
                      fontWeight: 300,
                      lineHeight: 1.38,
                      letterSpacing: "-0.012em",
                      marginTop: 6,
                      textWrap: "pretty",
                    }}
                  >
                    {m.quote}
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 16, marginTop: 30 }}>
                    <div style={{ width: 44, height: 2, background: "#7D010C" }} />
                    <div>
                      <div style={{ fontSize: 18, fontWeight: 700 }}>{m.name}</div>
                      <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: "#7D010C", marginTop: 3 }}>
                        {m.role}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div
        id="mission"
        style={{ marginTop: 96, position: "relative", background: "linear-gradient(150deg, #14100f, #050506)", color: "#fff", overflow: "hidden" }}
        data-screen-label="Mission"
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "radial-gradient(760px 380px at 88% -10%, rgba(125,1,12,0.45), transparent 62%)",
            pointerEvents: "none",
          }}
        />
        <div style={{ position: "relative", zIndex: 2, maxWidth: 1120, margin: "0 auto", padding: "96px clamp(20px, 5vw, 40px)" }}>
          {MISSION_VISION.map((b) => (
            <div
              key={b.num}
              className="mvrow rv"
              style={{
                display: "grid",
                gridTemplateColumns: "0.5fr 1.5fr",
                gap: 40,
                alignItems: "start",
                padding: "44px 0",
                borderTop: "1px solid rgba(255,255,255,0.14)",
              }}
            >
              <div>
                <div style={{ fontSize: "clamp(52px, 9vw, 84px)", fontWeight: 800, lineHeight: 0.9, color: "rgba(255,255,255,0.14)", letterSpacing: "-0.03em" }}>
                  {b.num}
                </div>
                <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.2em", textTransform: "uppercase", color: "#ff8f98", marginTop: 12 }}>
                  {b.label}
                </div>
              </div>
              <div>
                <div style={{ fontSize: "clamp(24px, 4.4vw, 38px)", fontWeight: 700, lineHeight: 1.16, letterSpacing: "-0.018em", textWrap: "balance" }}>
                  {b.title}
                </div>
                <div style={{ fontSize: 16, lineHeight: 1.75, color: "rgba(255,255,255,0.76)", marginTop: 18, maxWidth: 620, textWrap: "pretty" }}>
                  {b.body}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div id="values" style={{ padding: "96px clamp(16px, 4vw, 40px) 20px" }} data-screen-label="Values">
        <div style={{ maxWidth: 1120, margin: "0 auto" }}>
          <div className="rv" style={{ display: "flex", alignItems: "flex-end", gap: 20, marginBottom: 40, flexWrap: "wrap" }}>
            <div style={{ fontSize: "clamp(28px, 6vw, 42px)", fontWeight: 800, letterSpacing: "-0.015em", lineHeight: 1.05 }}>
              What we hold
              <br />
              ourselves to
            </div>
            <div className="chip" style={{ marginLeft: "auto" }}>
              Four principles
            </div>
          </div>
          <div>
            {VALUES.map((v) => (
              <div
                key={v.n}
                className="vrow rv"
                style={{
                  display: "grid",
                  gridTemplateColumns: "92px 1.1fr 1.4fr",
                  gap: 26,
                  alignItems: "center",
                  padding: "30px 18px",
                  borderTop: "1px solid rgba(26,20,22,0.13)",
                  borderRadius: 16,
                }}
              >
                <div className="vnum" style={{ fontSize: 30, fontWeight: 800, color: "#c4bec6", letterSpacing: "-0.02em" }}>
                  {v.n}
                </div>
                <div style={{ fontSize: "clamp(19px, 2.6vw, 24px)", fontWeight: 700, letterSpacing: "-0.01em" }}>{v.t}</div>
                <div style={{ fontSize: 14.5, lineHeight: 1.65, color: "#6b6470", textWrap: "pretty" }}>{v.d}</div>
              </div>
            ))}
            <div style={{ borderTop: "1px solid rgba(26,20,22,0.13)" }} />
          </div>
        </div>
      </div>

      <div id="articles" style={{ padding: "96px clamp(16px, 4vw, 40px) 20px" }} data-screen-label="Articles">
        <div style={{ maxWidth: 1120, margin: "0 auto" }}>
          <div className="rv" style={{ display: "flex", alignItems: "flex-end", gap: 20, marginBottom: 40, flexWrap: "wrap" }}>
            <div style={{ fontSize: "clamp(28px, 6vw, 42px)", fontWeight: 800, letterSpacing: "-0.015em", lineHeight: 1.05 }}>Articles & insights</div>
            <span className="btn" style={{ marginLeft: "auto", opacity: 0.7, cursor: "default" }}>
              View all
              <ArrowRight size={14} />
            </span>
          </div>
          <div className="artgrid" style={{ display: "grid", gridTemplateColumns: "1.25fr 1fr", gap: 24, alignItems: "start" }}>
            <div className="art rv" style={{ display: "block", color: "inherit" }}>
              <div style={{ position: "relative", aspectRatio: "16 / 10", borderRadius: 26, overflow: "hidden", boxShadow: "0 26px 60px rgba(50,25,30,0.16)" }}>
                <div className="art-img" style={{ position: "absolute", inset: 0 }}>
                  <div className="img-slot-empty">Featured article image</div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  fontSize: 11.5,
                  fontWeight: 700,
                  letterSpacing: "0.12em",
                  textTransform: "uppercase",
                  color: "#7D010C",
                  marginTop: 22,
                }}
              >
                Operations
                <span style={{ color: "#b3adb5", fontWeight: 500, letterSpacing: 0 }}>Jul 2026</span>
              </div>
              <div style={{ fontSize: "clamp(22px, 3vw, 28px)", fontWeight: 700, marginTop: 12, lineHeight: 1.24, letterSpacing: "-0.015em", textWrap: "pretty" }}>
                Why COD is still the hardest part of Egyptian e-commerce
              </div>
              <div style={{ fontSize: 14.5, lineHeight: 1.65, color: "#6b6470", marginTop: 12, maxWidth: 520 }}>
                Cash on delivery drives most orders in the market — and most of the operational pain. Here's how we handle it.
              </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
              {SMALL_ARTICLES.map((a) => (
                <div key={a.title} className="art rv card" style={{ display: "block", color: "inherit", padding: 18, overflow: "hidden" }}>
                  <div className="artsmall" style={{ display: "grid", gridTemplateColumns: "128px 1fr", gap: 18, alignItems: "center" }}>
                    <div style={{ position: "relative", aspectRatio: "1 / 1", borderRadius: 16, overflow: "hidden" }}>
                      <div className="art-img" style={{ position: "absolute", inset: 0 }}>
                        <div className="img-slot-empty" style={{ fontSize: 11 }}>
                          {a.cat}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 9,
                          fontSize: 11,
                          fontWeight: 700,
                          letterSpacing: "0.12em",
                          textTransform: "uppercase",
                          color: "#7D010C",
                        }}
                      >
                        {a.cat}
                        <span style={{ color: "#b3adb5", fontWeight: 500, letterSpacing: 0 }}>{a.date}</span>
                      </div>
                      <div style={{ fontSize: 17, fontWeight: 700, marginTop: 9, lineHeight: 1.3, letterSpacing: "-0.01em", textWrap: "pretty" }}>
                        {a.title}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <div
                className="rv card"
                style={{
                  padding: "26px 24px",
                  background: "linear-gradient(150deg, #14100f, #050506)",
                  borderColor: "rgba(255,255,255,0.08)",
                }}
              >
                <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.16em", textTransform: "uppercase", color: "#ff8f98" }}>Newsletter</div>
                <div style={{ fontSize: 19, fontWeight: 700, color: "#fff", marginTop: 10, lineHeight: 1.3 }}>Operations notes, once a month</div>
                <div
                  style={{
                    display: "flex",
                    gap: 8,
                    background: "rgba(255,255,255,0.08)",
                    border: "1px solid rgba(255,255,255,0.16)",
                    borderRadius: 999,
                    padding: "5px 6px 5px 18px",
                    alignItems: "center",
                    marginTop: 18,
                  }}
                >
                  <span style={{ fontSize: 13, color: "rgba(255,255,255,0.55)", flex: 1 }}>Enter your email</span>
                  <span className="btn red" style={{ padding: "9px 18px" }}>
                    Subscribe
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="about-cta" style={{ padding: "96px clamp(16px, 4vw, 40px) 90px" }} data-screen-label="AboutCTA">
        <div
          className="rv"
          style={{
            maxWidth: 1120,
            margin: "0 auto",
            position: "relative",
            borderRadius: 34,
            overflow: "hidden",
            minHeight: 400,
            background: "linear-gradient(150deg, #14100f, #050506)",
            border: "1px solid rgba(255,255,255,0.08)",
            boxShadow: "0 30px 70px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.06)",
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "radial-gradient(700px 340px at 85% 0%, rgba(125,1,12,0.4), transparent 62%)",
              pointerEvents: "none",
            }}
          />
          <div style={{ position: "relative", zIndex: 2, padding: "70px 50px", maxWidth: 620 }}>
            <div style={{ fontSize: "clamp(32px, 7vw, 46px)", fontWeight: 800, color: "#fff", lineHeight: 1.06, letterSpacing: "-0.02em" }}>
              Want to build with us?
            </div>
            <div style={{ fontSize: 17, color: "rgba(255,255,255,0.88)", marginTop: 16, lineHeight: 1.6 }}>
              Whether you're a brand looking to hand over operations or a team that wants to join ours — we'd like to hear from you.
            </div>
            <div style={{ display: "flex", gap: 13, marginTop: 30, flexWrap: "wrap" }}>
              <Link className="btn red" to="/book?intent=partnership" style={{ padding: "15px 30px", fontSize: 15 }}>
                Become a Partner
                <ArrowRight />
              </Link>
              <Link className="btn ghost-lite" to="/contact" style={{ padding: "15px 30px", fontSize: 15 }}>
                Join the team
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
